export default {
  playList: 'Playlist',
  yunduanku: 'Cloud Library',
  myList: 'My Playlists',
  searchPlaceholder: 'Input keywords to search',
  searchButton: 'Search',

  saveList: 'Save the list',
  sendRes: 'Send resources',
  clearList: 'Clear the list',
  loading: 'Loading',
  empty: 'Empty',

  saveAsList: 'Save as a list',
  okText: 'Save',
  pleaseInputListName: 'Please input the list name',
  max20: '40 characters limited',
  all: 'All',

  xuekeshuxing: 'by Subject',
  ziranshuxing: 'by General',
  playListEmpty: 'Please create your playlist by dragging and dropping the resources to the right side.',
  listIsEmpty: 'The list is empty.',
  saveDone: 'Save successfully',

  // tslint:disable-next-line: max-line-length
  resSending: 'The resources in the list are sent to the devices, you can check the process of sending and installing in the sector of "Installation Details".',
  resSendDone: 'Send successfully',
  clearListTip: 'After clearing the list, you also can add resources into the list.',
  clearListConfirm: 'Do you want to clear the list?？',
  titleEmpty: 'Please enter the lesson name or select an existing lesson!',


  // 筛选条件
  resType: 'Type',
  cateType: 'Attribute',
  generalCate: 'Category',
  phase: 'Stage',
  generalSubCate: 'Subcategory',
  subject: 'Subject',
  grade: 'Grade',
  volume: 'Volume',

  alreadyAdded: 'Already added',
  addDone: 'Add successfully',

  cannotFind: 'Can not find ',
  no: 'No ',
  prev: 'Previous',
  next: 'Next',

  playAddSuccess: 'Already added',
  playAddExist: 'aready exist',
}
